import type { NonEnLang } from './languages';

export const GUIDE_SLUG_TRANS: Record<string, Partial<Record<NonEnLang, string>>> = {
  'is-croatia-expensive-2026': {
    de: 'ist-kroatien-teuer-2026',
    fr: 'croatie-est-elle-chere-2026',
    it: 'croazia-cara-2026',
    nl: 'is-kroatie-duur-2026',
    hr: 'je-li-hrvatska-skupa-2026',
    pl: 'czy-chorwacja-jest-droga-2026',
  },
  'best-time-to-visit-croatia': {
    de: 'beste-reisezeit-kroatien',
    fr: 'meilleure-periode-visiter-croatie',
    it: 'periodo-migliore-visitare-croazia',
    nl: 'beste-tijd-kroatie-bezoeken',
    hr: 'najbolje-vrijeme-za-posjet-hrvatskoj',
    pl: 'najlepszy-czas-na-wizyte-w-chorwacji',
  },
  'croatia-in-october': {
    de: 'kroatien-im-oktober',
    fr: 'croatie-en-octobre',
    it: 'croazia-a-ottobre',
    nl: 'kroatie-in-oktober',
    hr: 'hrvatska-u-listopadu',
    pl: 'chorwacja-w-pazdzierniku',
  },
  'split-vs-dubrovnik': {
    de: 'split-oder-dubrovnik',
    fr: 'split-ou-dubrovnik',
    it: 'spalato-o-dubrovnik',
    nl: 'split-of-dubrovnik',
    hr: 'split-ili-dubrovnik',
    pl: 'split-czy-dubrownik',
  },
  'hvar-vs-brac': {
    de: 'hvar-oder-brac',
    fr: 'hvar-ou-brac',
    it: 'hvar-contro-brac',
    nl: 'hvar-of-brac',
    hr: 'hvar-ili-brac',
    pl: 'hvar-kontra-brac',
  },
  'zadar-vs-sibenik': {
    de: 'zadar-oder-sibenik',
    fr: 'zadar-contre-sibenik',
    it: 'zadar-contro-sibenik',
    nl: 'zadar-of-sibenik',
    hr: 'zadar-ili-sibenik',
    pl: 'zadar-kontra-sibenik',
  },
  'croatia-budget-travel-guide': {
    de: 'kroatien-guenstig-reisen',
    fr: 'croatie-voyage-petit-budget',
    it: 'croazia-viaggi-economici-guida',
    nl: 'kroatie-budget-reizen-gids',
    hr: 'vodic-jeftino-putovanje-hrvatska',
    pl: 'chorwacja-przewodnik-budzet',
  },
  'croatia-island-hopping-guide': {
    de: 'kroatien-inselhopping-guide',
    fr: 'croatie-guide-saut-iles',
    it: 'croazia-guida-island-hopping',
    nl: 'kroatie-eilanden-hoppen-gids',
    hr: 'vodic-obilazak-otoka-hrvatska',
    pl: 'chorwacja-przewodnik-wyspa-do-wyspy',
  },
  'dubrovnik-travel-guide': {
    de: 'dubrovnik-reisefuehrer',
    fr: 'guide-voyage-dubrovnik',
    it: 'guida-viaggio-dubrovnik',
    nl: 'dubrovnik-reisgids',
    hr: 'vodic-dubrovnik',
    pl: 'przewodnik-dubrownik',
  },
  'plitvice-lakes-visitor-guide': {
    de: 'plitvicer-seen-besucherfuehrer',
    fr: 'guide-visiteur-lacs-de-plitvice',
    it: 'guida-visitatore-laghi-di-plitvice',
    nl: 'plitvice-meren-bezoekersgids',
    hr: 'vodic-plitvicka-jezera',
    pl: 'przewodnik-jeziora-plitwickie',
  },
  'krka-visitor-guide': {
    de: 'krka-besucherfuehrer',
    fr: 'guide-visiteur-krka',
    it: 'guida-visitatore-krka',
    nl: 'krka-bezoekersgids',
    hr: 'vodic-krka',
    pl: 'przewodnik-krka',
  },
  'kornati-visitor-guide': {
    de: 'kornati-besucherfuehrer',
    fr: 'guide-visiteur-kornati',
    it: 'guida-visitatore-kornati',
    nl: 'kornati-bezoekersgids',
    hr: 'vodic-kornati',
    pl: 'przewodnik-kornati',
  },
  'mljet-visitor-guide': {
    de: 'mljet-besucherfuehrer',
    fr: 'guide-visiteur-mljet',
    it: 'guida-visitatore-mljet',
    nl: 'mljet-bezoekersgids',
    hr: 'vodic-mljet',
    pl: 'przewodnik-mljet',
  },
  'paklenica-visitor-guide': {
    de: 'paklenica-besucherfuehrer',
    fr: 'guide-visiteur-paklenica',
    it: 'guida-visitatore-paklenica',
    nl: 'paklenica-bezoekersgids',
    hr: 'vodic-paklenica',
    pl: 'przewodnik-paklenica',
  },
  'risnjak-visitor-guide': {
    de: 'risnjak-besucherfuehrer',
    fr: 'guide-visiteur-risnjak',
    it: 'guida-visitatore-risnjak',
    nl: 'risnjak-bezoekersgids',
    hr: 'vodic-risnjak',
    pl: 'przewodnik-risnjak',
  },
  'brijuni-visitor-guide': {
    de: 'brijuni-besucherfuehrer',
    fr: 'guide-visiteur-brijuni',
    it: 'guida-visitatore-brijuni',
    nl: 'brijuni-bezoekersgids',
    hr: 'vodic-brijuni',
    pl: 'przewodnik-brijuni',
  },
  'sjeverni-velebit-visitor-guide': {
    de: 'nordlicher-velebit-besucherfuehrer',
    fr: 'guide-visiteur-velebit-nord',
    it: 'guida-visitatore-velebit-nord',
    nl: 'noord-velebit-bezoekersgids',
    hr: 'vodic-sjeverni-velebit',
    pl: 'przewodnik-velebit-polnocny',
  },
  'croatia-hidden-gems': {
    de: 'kroatien-geheimtipps',
    fr: 'croatie-tresors-caches',
    it: 'croazia-gemme-nascoste',
    nl: 'kroatie-verborgen-pareltjes',
    hr: 'skriveni-biseri-hrvatske',
    pl: 'chorwacja-ukryte-skarby',
  },
  'split-travel-guide': {
    de: 'split-reisefuehrer',
    fr: 'guide-voyage-split',
    it: 'guida-viaggio-split',
    nl: 'split-reisgids',
    hr: 'vodic-split',
    pl: 'przewodnik-split',
  },
  'zagreb-travel-guide': {
    de: 'zagreb-reisefuehrer',
    fr: 'guide-voyage-zagreb',
    it: 'guida-viaggio-zagreb',
    nl: 'zagreb-reisgids',
    hr: 'vodic-zagreb',
    pl: 'przewodnik-zagrzeb',
  },
  'croatia-camping-guide': {
    de: 'kroatien-camping-guide',
    fr: 'guide-camping-croatie',
    it: 'guida-campeggio-croazia',
    nl: 'kroatie-kampeer-gids',
    hr: 'vodic-kampiranje-hrvatska',
    pl: 'chorwacja-przewodnik-kemping',
  },
  'dalmatia-travel-guide': {
    de: 'dalmatien-reisefuehrer',
    fr: 'guide-voyage-dalmatie',
    it: 'guida-viaggio-dalmazia',
    nl: 'dalmatia-reisgids',
    hr: 'vodic-dalmacija',
    pl: 'przewodnik-dalmacja',
  },
  'istria-travel-guide': {
    de: 'istrien-reisefuehrer',
    fr: 'guide-voyage-istrie',
    it: 'guida-viaggio-istria',
    nl: 'istrie-reisgids',
    hr: 'vodic-istra',
    pl: 'przewodnik-istria',
  },
  'croatia-road-trip-guide': {
    de: 'kroatien-roadtrip-guide',
    fr: 'croatie-guide-road-trip',
    it: 'croazia-guida-road-trip',
    nl: 'kroatie-roadtrip-gids',
    hr: 'vodic-road-trip-hrvatska',
    pl: 'chorwacja-przewodnik-road-trip',
  },
  'sinjska-alka-guide': {
    de: 'sinjska-alka-guide-de',
    fr: 'guide-sinjska-alka',
    it: 'guida-sinjska-alka',
    nl: 'sinjska-alka-gids',
    hr: 'vodic-sinjska-alka',
    pl: 'przewodnik-sinjska-alka',
  },
  'croatia-national-parks-guide': {
    de: 'kroatien-nationalparks-guide',
    fr: 'guide-parcs-nationaux-croatie',
    it: 'guida-parchi-nazionali-croazia',
    nl: 'kroatie-nationale-parken-gids',
    hr: 'vodic-nacionalni-parkovi-hrvatska',
    pl: 'chorwacja-przewodnik-parki-narodowe',
  },
  'croatia-with-children': {
    de: 'kroatien-mit-kindern',
    fr: 'croatie-avec-enfants',
    it: 'croazia-con-bambini',
    nl: 'kroatie-met-kinderen',
    hr: 'hrvatska-s-djecom',
    pl: 'chorwacja-z-dziecmi',
  },
  'easter-holidays-croatia': {
    de: 'ostern-in-kroatien',
    fr: 'paques-en-croatie',
    it: 'pasqua-in-croazia',
    nl: 'pasen-in-kroatie',
    hr: 'uskrs-u-hrvatskoj',
    pl: 'wielkanoc-w-chorwacji',
  },
  'split-hotels-parking': {
    de: 'hotels-split-mit-parkplatz',
    fr: 'hotels-split-avec-parking',
    it: 'hotel-split-con-parcheggio',
    nl: 'hotels-split-met-parkeerplaats',
    hr: 'hoteli-split-s-parkiranjem',
    pl: 'hotele-split-z-parkingiem',
  },
  'dubrovnik-hotels-parking': {
    de: 'hotels-dubrovnik-mit-parkplatz',
    fr: 'hotels-dubrovnik-avec-parking',
    it: 'hotel-dubrovnik-con-parcheggio',
    nl: 'hotels-dubrovnik-met-parkeerplaats',
    hr: 'hoteli-dubrovnik-s-parkiranjem',
    pl: 'hotele-dubrownik-z-parkingiem',
  },
  'zadar-travel-guide': {
    de: 'zadar-reisefuehrer',
    fr: 'guide-voyage-zadar',
    it: 'guida-viaggio-zadar',
    nl: 'zadar-reisgids',
    hr: 'vodic-zadar',
    pl: 'przewodnik-zadar',
  },
  'is-cavtat-expensive': {
    de: 'ist-cavtat-teuer',
    fr: 'cavtat-est-il-cher',
    it: 'cavtat-e-costosa',
    nl: 'is-cavtat-duur',
    hr: 'je-li-cavtat-skup',
    pl: 'czy-cavtat-jest-drogi',
  },
  'where-not-to-go-in-croatia': {
    de: 'wohin-nicht-in-kroatien',
    fr: 'ou-ne-pas-aller-en-croatie',
    it: 'dove-non-andare-in-croazia',
    nl: 'waar-niet-naartoe-in-kroatie',
    hr: 'gdje-ne-ici-u-hrvatskoj',
    pl: 'gdzie-nie-jechac-w-chorwacji',
  },
  'is-dubrovnik-expensive': {
    de: 'ist-dubrovnik-teuer',
    fr: 'dubrovnik-est-il-cher',
    it: 'dubrovnik-e-costosa',
    nl: 'is-dubrovnik-duur',
    hr: 'je-li-dubrovnik-skup',
    pl: 'czy-dubrownik-jest-drogi',
  },
  'is-split-expensive': {
    de: 'ist-split-teuer',
    fr: 'split-est-il-cher',
    it: 'split-e-costoso',
    nl: 'is-split-duur',
    hr: 'je-li-split-skup',
    pl: 'czy-split-jest-drogi',
  },
  'is-hvar-expensive': {
    de: 'ist-hvar-teuer',
    fr: 'hvar-est-il-cher',
    it: 'hvar-e-costosa',
    nl: 'is-hvar-duur',
    hr: 'je-li-hvar-skup',
    pl: 'czy-hvar-jest-drogi',
  },
  'best-beaches-croatia': {
    de: 'beste-straende-kroatien',
    fr: 'meilleures-plages-croatie',
    it: 'migliori-spiagge-croazia',
    nl: 'beste-stranden-kroatie',
    hr: 'najbolje-plaze-hrvatska',
    pl: 'najlepsze-plaze-chorwacja',
  },
  'vinistra-wine-festival-guide': {
    de: 'vinistra-weinfestival-guide',
    fr: 'vinistra-festival-vin-guide',
    it: 'vinistra-festival-vino-guida',
    nl: 'vinistra-wijnfestival-gids',
    hr: 'vinistra-festival-vina-vodic',
    pl: 'vinistra-festiwal-wina-przewodnik',
  },
  'makarska-tourism-boom-2026': {
    de: 'makarska-tourismus-boom-2026',
    fr: 'boom-tourisme-makarska-2026',
    it: 'boom-turismo-makarska-2026',
    nl: 'makarska-toerisme-boom-2026',
    hr: 'makarska-turisticki-boom-2026',
    pl: 'makarska-boom-turystyczny-2026',
  },
  'croatia-border-delays-ees-2026': {
    de: 'kroatien-grenzverzoegerungen-ees-2026',
    fr: 'retards-frontieres-croatie-ees-2026',
    it: 'ritardi-frontiera-croazia-ees-2026',
    nl: 'kroatie-grensvertragingen-ees-2026',
    hr: 'zastoji-na-granicama-hrvatske-ees-2026',
    pl: 'chorwacja-opoznienia-graniczne-ees-2026',
  },
  'united-airlines-split-new-york-2026': {
    de: 'united-airlines-direktflug-split-new-york-2026',
    fr: 'united-airlines-vol-direct-split-new-york-2026',
    it: 'united-airlines-volo-diretto-spalato-new-york-2026',
    nl: 'united-airlines-directe-vlucht-split-new-york-2026',
    hr: 'united-airlines-direktni-let-split-new-york-2026',
    pl: 'united-airlines-bezposredni-lot-split-nowy-jork-2026',
  },
  'plitvice-vs-krka': {
    de: 'plitvicer-seen-vs-krka-nationalpark',
    fr: 'lacs-plitvice-vs-krka-parc-national',
    it: 'laghi-plitvice-vs-krka-parco-nazionale',
    nl: 'plitvice-meren-vs-krka-nationaal-park',
    hr: 'plitvicka-jezera-vs-krka-nacionalni-park',
    pl: 'jeziora-plitwickie-vs-krka-park-narodowy',
  },
  'rovinj-vs-porec': {
    de: 'rovinj-oder-porec',
    fr: 'rovigno-ou-porec',
    it: 'rovigno-o-parenzo',
    nl: 'rovinj-of-porec',
    hr: 'rovinj-ili-porec',
    pl: 'rovinj-czy-porec',
  },
  'hidden-gems-croatia': {
    de: 'geheimtipps-kroatien',
    fr: 'tresors-caches-croatie',
    it: 'luoghi-nascosti-croazia',
    nl: 'verborgen-parels-kroatie',
    hr: 'skriveni-biseri-hrvatske',
    pl: 'ukryte-skarby-chorwacji',
  },
  'croatia-vs-greece': {
    de: 'kroatien-oder-griechenland',
    fr: 'croatie-ou-grece',
    it: 'croazia-o-grecia',
    nl: 'kroatie-of-griekenland',
    hr: 'hrvatska-ili-grcka',
    pl: 'chorwacja-czy-grecja',
  },
  'croatia-mainland-vs-island': {
    de: 'festland-oder-insel-kroatien',
    fr: 'croatie-continent-ou-ile',
    it: 'croazia-terraferma-o-isola',
    nl: 'kroatie-vasteland-of-eiland',
    hr: 'hrvatska-kopno-ili-otok',
    pl: 'chorwacja-lad-czy-wyspa',
  },
};
